<div id="informativeContent" class='clearfix'>
	<div id="actionElements">
		<button class='btn btn-save btn-lg' (click)='openMultiFactorDeviceModal()'>Register Device</button>
	</div>
	<div>
		Physical authentication devices which are U2F/FIDO2 compatible can be added here. To add a new authentication device, click the Register Device button.
	</div>
</div>
<pcg-table #credentialTable [showTableTop]="false" [canGlobalSearch]="false" [showPagination]="false"
		   [ajaxData]='{ userId: id }' [serverSide]='false' [pcgSort]='[[ "displayName", "asc" ]]'
	dataSource='api/Administration/Users/GetCredentialList' [columnDefs]='credColumns'>

	<ng-container cdkColumnDef="displayName">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>Display Name</th>
		<td cdk-cell *cdkCellDef='let row'>
			{{ row.displayName }}
		</td>
	</ng-container>

	<ng-container cdkColumnDef="dateGenerated">
		<th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>Date Generated</th>
		<td cdk-cell *cdkCellDef='let row'>
			{{ row.dateGeneratedFormatted }}
		</td>
	</ng-container>

	<ng-container cdkColumnDef="delete">
		<th class="text-center" cdk-header-cell *cdkHeaderCellDef>Delete</th>
		<td class="text-center" cdk-cell *cdkCellDef='let row'>
			<button (click)='deleteRecord({ userId: id, id: row.credentialId })' class='delete'>
				<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'
					viewBox='0 0 300 300'>
					<g id='layer1'>
						<path d='M 100,60 L 60,100 L 230,270 L 270,230 L 100,60 z ' id='path4950'
							style='fill:#e00;fill-opacity:1;' />
						<path d='M 60,230 L 230,60 L 270,100 L 100,270 L 60,230 z ' id='path4952'
							style='fill:#e00;stroke-opacity:1' />
					</g>
				</svg>
			</button>
		</td>
	</ng-container>
</pcg-table>
